module.exports = __webpack_public_path__ + "img/index-logo.32739512.png";